import React from "react";
import logo from "../assets/logo.svg";
import { Link } from "react-router-dom";
import { Box, Center, Flex, Text } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import ForgotPasswordForm from "../component/ForgotPasswordForm";
import { useAuth } from "../context/authContext";

const ForgotPassword = () => {
  const auth = useAuth();
  //   const history = useHistory();

  const forgotPassword = async (data, token) => {
    await auth
      .forgotPassword(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  return (
    <Flex sx={{ minHeight: "100vh" }} justify="center" bg="#223D5D" py={8}>
      <Box>
        <Center>
          <Center>
            <Link to="/">
              <img height="126px" width="345px" src={logo} alt="logo" />
            </Link>
          </Center>
        </Center>

        <Box
          bg="white"
          mt={6}
          pt={16}
          sx={{
            maxWidth: "445px",
            minHeight: "410px",
            borderRadius: "10px",
            fontWeight: 510,
          }}
        >
          <ForgotPasswordForm forgotPassword={forgotPassword} />

          <Box sx={{ borderRadius: "inherit" }}>
            <Box px={8}>
              <Link>
                <Flex mt={10}>
                  <Box color="#223D5D">
                    <FontAwesomeIcon icon={faArrowLeft} />
                  </Box>
                  <Link to="/login">
                    <Text color="#00A2E8" pl={5} m={0}>
                      Login to Learnerkia
                    </Text>
                  </Link>
                </Flex>
              </Link>
            </Box>
          </Box>
        </Box>
      </Box>
    </Flex>
  );
};

export default ForgotPassword;
